module.exports = __webpack_public_path__ + "media/erosion.50183ee3.wav";